





















import {Component, Prop, Vue} from "nuxt-property-decorator";

@Component({})
export default class ProductPrice extends Vue {
  @Prop({type: Number}) private readonly price!: number;
  @Prop({type: Number}) private readonly oldPrice!: number;
  @Prop({type: Number}) private readonly newPrice!: number;
  @Prop({type: String}) private readonly currency!: string;
  @Prop({type: Array}) private readonly promotions?: any;

  get productPrice(): string {
    const productPromoPrice: any = this.productPromoPrice;
    if (productPromoPrice.priceProduct) {
      return this.formatPrice(productPromoPrice?.priceProduct);
    }

    return this.formatPrice(this.newPrice || this.price);
  }
  get productOldPrice(): string {
    const productPromoPrice: any = this.productPromoPrice;
    if (productPromoPrice.priceProduct) {
      return this.formatPrice(this.newPrice || this.price);
    }

    return this.oldPrice > this.price ? this.formatPrice(this.oldPrice) : "";
  }

  get productPromoPrice(): object {
    const productPrice = this.newPrice || this.price;

    let promotions = (this.promotions || []).filter((promotion: any) => promotion?.visualProfitType);
    if (promotions.length <= 0) {
      return {}
    }

    let promotionMin = {};
    let minProductPrice = productPrice;
    this.promotions.map((promotion: any) => {
      const visualProfitType: any = promotion.visualProfitType;
      const visualProfitValue: any = promotion.visualProfitValue;

      let newProductPrice: any = productPrice;
      if (visualProfitType === "percent") {
        newProductPrice = Math.round(newProductPrice - ((newProductPrice / 100) * Number.parseFloat(visualProfitValue)));
      }
      if (visualProfitType === "fixed") {
        newProductPrice = newProductPrice - Number.parseFloat(visualProfitValue);
      }

      if (newProductPrice > 0 && newProductPrice < minProductPrice) {
        promotionMin = {
          ...promotion,
          priceProduct: newProductPrice
        }
        minProductPrice = newProductPrice;
      }
    })

    return  promotionMin
  }

  formatPrice(price: number): string {
    return new Intl.NumberFormat("ru-RU").format(price);
  }
}
